"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var NotificationsFillSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M11.5569,16 C11.2709,16.868 10.4619,17.5 9.4999,17.5 C8.5379,17.5 7.7289,16.868 7.4429,16 L7.4429,16 Z M9.4997,2.9996 C10.3517,2.9996 11.0647,3.5746 11.2707,4.3796 C12.9147,5.0856 13.9997,6.7056 13.9997,8.4996 L13.9997,8.4996 L13.9997,11.1616 L15.4497,13.6426 C15.6147,13.9246 15.6167,14.2616 15.4537,14.5446 C15.2917,14.8286 14.9997,14.9966 14.6727,14.9966 L14.6727,14.9966 L4.3267,14.9966 C4.0007,14.9966 3.7087,14.8286 3.5467,14.5446 C3.3837,14.2616 3.3857,13.9246 3.5507,13.6426 L3.5507,13.6426 L4.9997,11.1616 L4.9997,8.4996 C4.9997,6.7056 6.0847,5.0856 7.7287,4.3796 C7.9357,3.5746 8.6487,2.9996 9.4997,2.9996 Z", fillRule: "evenodd" })));
};
NotificationsFillSmall.displayName = 'NotificationsFillSmall';
exports.default = NotificationsFillSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=NotificationsFillSmall.js.map